import { Injectable, Injector, ProviderToken, inject } from '@angular/core';
import {
  BdResource,
  ShareableType,
  BdResourceService,
  ResourceRegistrationToken,
} from '@bindoc-projects/resource-domain-lib';
import { RESOURCE_REGISTRATION } from './token';

@Injectable({
  providedIn: 'root',
})
export class BdResourceServices {
  // RESOURCE_REGISTRATION is a `multi: true` token, so it resolves to an array
  // at runtime; the token's element type must be widened to the array form here.
  private _resourceRegistration = inject<ResourceRegistrationToken[]>(
    RESOURCE_REGISTRATION as ProviderToken<ResourceRegistrationToken[]>,
  );
  private readonly injector = inject(Injector);

  public of<TResource extends BdResource>(
    resourceName: ShareableType,
  ): BdResourceService<TResource> {
    const targetService = this._resourceRegistration.find(
      (it) => it.resourceName === resourceName,
    );
    if (targetService) {
      const token = targetService.resourceService as ProviderToken<
        BdResourceService<TResource>
      >;
      return this.injector.get(token);
    } else {
      throw new Error(`Resource ${resourceName} has no service implemented`);
    }
  }
}
